// Opportunity datasets the competitor script pipeline can write scripts for.

/**
 * Only Topics opportunities carry the evidence the competitor script prompts need.
 * Shared because the web gate dialog and the API generate route must agree on it.
 */
export const SCRIPT_GENERATION_DATASETS: readonly string[] = ['Topics'];

/** Dataset the gate dialog suggests filtering to. */
export const SCRIPT_GENERATION_DATASET = 'Topics';

export function isScriptGenerationDataset(dataset: string | null | undefined): boolean {
  return dataset != null && SCRIPT_GENERATION_DATASETS.includes(dataset);
}
